import React from 'react';
import { Clock, Star, Users, Book } from 'lucide-react';
import Button from '../../components/ui/Button';

const CourseDetails = () => {
    const course = {
        id: 1,
        title: 'Advanced Mathematics',
        description: 'Master calculus, linear algebra, and advanced mathematical concepts.',
        instructor: 'Dr. Sarah Johnson',
        rating: 4.7,
        students: 1250,
        duration: '12 weeks',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        price: 199,
        availability: "Morning",
    };

    return (
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            {/* Cover Image and Content Container */}
            <div className="relative">
                <img src={course.image} alt="Course Cover" className="w-full h-80 object-cover" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent py-4 px-6">
                    <h2 className="text-4xl font-bold text-white">{course.title}</h2>
                    <p className="text-lg text-white mt-2">{course.description}</p>
                </div>
            </div>

            {/* Course Details Section */}
            <div className="flex flex-col md:flex-row p-6 bg-gray-50">
                {/* Left Side: Course Description */}
                <div className="md:w-2/3">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">About This Course</h3>
                    <p className="text-gray-600">{course.description}</p>
                </div>

                {/* Right Side: Course Details */}
                <div className="md:w-1/3 md:pl-8 mt-6 md:mt-0 bg-white p-6 rounded-lg shadow-lg">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4">Course Details</h3>
                    <div className="flex items-center mb-4">
                        <Clock className="h-5 w-5 text-gray-400 mr-2" />
                        <span className="font-medium">{course.duration}</span>
                    </div>
                    <div className="flex items-center mb-4">
                        <Star className="h-5 w-5 text-yellow-400 mr-2" />
                        <span className="font-medium">{course.rating} Stars</span>
                    </div>
                    <div className="flex items-center mb-4">
                        <Users className="h-5 w-5 text-gray-400 mr-2" />
                        <span className="font-medium">{course.students} students enrolled</span>
                    </div>
                    <div className="flex items-center mb-4">
                        <Book className="h-5 w-5 text-indigo-600 mr-2" />
                        <span className="font-medium">${course.price}</span>
                    </div>

                    {/* Enroll Now Button */}
                    <Button size="lg" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white">
                        Enroll Now
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CourseDetails;
